export const disableTableHeaders = (columns, data) => (config, t) =>
  data?.length ? columns(config, t) : columns({ ...config, disabled: true }, t);
